// import { motion } from "framer-motion";
import { cn } from "~/lib/utils";
import type { GlowColor } from "./_types";

interface BannerProps {
  size?: "md" | "lg";
  url: string;
  alt: string;
  glow?: GlowColor;
}

export default function Banner({ glow, size, url, alt }: BannerProps) {
  return (
    <div
      // viewport={{ once: true }}
      // variants={social_link_motion}
      // initial="hidden"
      // whileInView="visible"
      // transition={{
        // delay: 0.7 * 0.1,
        // type: "spring",
        // stiffness: 100,
      // }}
      className="relative w-full"
    >
      {
        url.endsWith(".svg")
        ? (
          <object data={url} type="image/svg+xml" className="relative w-full rounded-4xl drop-shadow-xl aspect-video object-cover"/>
        )
        : (
          <img
            src={url}
            alt={alt}
            className={cn("relative z-10 w-full rounded-4xl drop-shadow-xl aspect-video object-cover",
          glow,
          size === "lg" ? "max-w-100 xl:max-w-lg" : "max-w-84 xl:max-w-96",)}
          />
        )
      }
    </div>
  );
}
